/** @module csi/table/matrix/ColumnEnumMap */
define([
	"dojo/_base/declare",
	"csi/table/matrix/ColumnEnum",
	"csi/xml"
], function(declare, ColumnEnum, xml) {

	return declare(ColumnEnum, {
		/**
		 * @override
		 * Set index for column to unique value from configured attribute if this is not a matrix group (no sub-specs)
		 */
		onPathSpecParams(ctx, params, columnIndex) {
			if (!params.subs) {
				this.onPathSubSpecParams(ctx, params, columnIndex);
			}
		},

		/**
		 * @override
		 * Set index for column to unique value from configured attribute
		 */
		onPathSubSpecParams: function(ctx, params, columnIndex) {
			const enumObj = ctx.getNodeAttributeValue("Value");
			params.index = xml.enumGetText(enumObj);
		}
	});
});